var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import colors from '../colors';
import { sizeMap } from './common';
export var Path = forwardRef(function (props, ref) {
    var _a = props.color, color = _a === void 0 ? colors.grey[900] : _a, _b = props.variant, variant = _b === void 0 ? 'default' : _b, _c = props.title, title = _c === void 0 ? '' : _c;
    var size = sizeMap[variant];
    return (_jsxs("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: [_jsx("title", { children: title }), _jsx("path", { d: "M16.5 17.65C16.5 18.8926 17.5074 19.9 18.75 19.9C19.9926 19.9 21 18.8926 21 17.65C21 16.4074 19.9926 15.4 18.75 15.4C17.5074 15.4 16.5 16.4074 16.5 17.65ZM16.5 17.65H6.75C5.75544 17.65 4.80161 17.2549 4.09835 16.5516C3.39509 15.8484 3 14.8946 3 13.9C3 12.9054 3.39509 11.9516 4.09835 11.2483C4.80161 10.5451 5.75544 10.15 6.75 10.15H15.75C16.5456 10.15 17.3087 9.83392 17.8713 9.27131C18.4339 8.70871 18.75 7.94564 18.75 7.14999C18.75 6.35434 18.4339 5.59128 17.8713 5.02867C17.3087 4.46606 16.5456 4.14999 15.75 4.14999H6.75", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })] })));
});
